import axios from 'axios'
import config from '../config'

const Performance = {
    state: {
        buPerformanceList: [],
        shopPerformanceList: [],
        userExcel: [],
        checkUserExcel: [],
        shopExcel: [],
        checkShopExcel: [],
        error: false,
        msg: ''
    },
    mutations: {
        userPerformanceList: (state, buPerformanceList) => state.buPerformanceList = buPerformanceList,
        shopPerformanceList: (state, shopPerformanceList) => state.shopPerformanceList = shopPerformanceList,
        UserExcel: (state, userExcel) => state.userExcel = userExcel,
        CheckUserExcel: (state, checkUserExcel) => state.checkUserExcel = checkUserExcel,
        ShopExcel: (state, shopExcel) => state.shopExcel = shopExcel,
        CheckShopExcel: (state, checkShopExcel) => state.checkShopExcel = checkShopExcel,
        ERROR: (state, error) => state.error = error,
        MSG: (state, msg) => state.msg = msg
    },
    actions: {
        async fetchBuPerformanceList({commit}, data){
            await axios({
                method:'post',
                url: config.LOAD_PERFORMANCE_USER_LIST,
                data: data
            })
            .then((result) => {
                commit('userPerformanceList', result.data.result)
            }).catch((err) => {
                console.log(err);
            });
        },
        async fetchShopPerformanceList({commit}, data){
            await axios({
                method:'post',
                url: config.LOAD_PERFORMANCE_SHOP_LIST,
                data: data
            })
            .then((result) => {
                commit('shopPerformanceList',result.data.result )
            }).catch((err) => {
                console.log(err);
            });
        },
        async fetchUserPerformanceExcel({commit}, data){
            await axios({
                method:'post',
                url: config.LOAD_PERFORMANCE_USER_EXCEL,
                data: data
            })
            .then((result) => {
                commit('UserExcel', result.data.excel)
            }).catch((err) => {
                console.log(err);
            });
        },
        async fetchCheckUserPerformanceExcel({commit}, data){
            await axios({
                method:'post',
                url: config.CHECK_PERFORMANCE_USER_EXCEL,
                data: data
            })
            .then((result) => {
                commit('CheckUserExcel', result.data.excel)
            }).catch((err) => {
                console.log(err);
            });
        },
        async fetchShopPerformanceExcel({commit}, data){
            await axios({
                method:'post',
                url: config.LOAD_PERFORMANCE_SHOP_EXCEL,
                data: data
            })
            .then((result) => {
                commit('ShopExcel', result.data.excel)
            }).catch((err) => {
                console.log(err);
            });
        },
        async fetchCheckShopPerformanceExcel({commit}, data){
            await axios({
                method:'post',
                url: config.CHECK_PERFORMANCE_SHOP_EXCEL,
                data: data
            })
            .then((result) => {
                commit('CheckShopExcel', result.data.excel)
            }).catch((err) => {
                console.log(err);
            });
        },
    },
    getters: {
        getUserPerformanceList: state => state.buPerformanceList,
        getShopPerformanceList: state => state.shopPerformanceList,
        getUserExcel: state => state.userExcel,
        getCheckUserExcel: state => state.checkUserExcel,
        getShopExcel: state => state.shopExcel,
        getCheckShopExcel: state => state.checkShopExcel,
        getPerformanceError: state => state.error,
        getPerformanceMsg: state => state.msg
    }
}

export default Performance;